/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const appointmentFilterOptionsLocationsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentFilterOptionsProvidersItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentFilterOptionsSourcesSavedItemRegExp = new RegExp('^[a-z0-9_-]{1,40}$')
export const appointmentFilterOptionsSourcesUnlistedItemRegExp = new RegExp('^[a-z0-9_-]{1,40}$')
export const appointmentFilterOptionsVisitTypesItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const AppointmentFilterOptions = zod.object({
  locations: zod.array(
    zod.object({
      id: zod.uuid().regex(appointmentFilterOptionsLocationsItemIdRegExp),
      name: zod.string(),
    }),
  ),
  providers: zod.array(
    zod.object({
      color: zod.string(),
      credentials: zod.string(),
      id: zod.uuid().regex(appointmentFilterOptionsProvidersItemIdRegExp),
      name: zod.string(),
    }),
  ),
  sources: zod.object({
    hasUnknown: zod.boolean(),
    saved: zod.array(zod.string().regex(appointmentFilterOptionsSourcesSavedItemRegExp)),
    unlisted: zod.array(zod.string().regex(appointmentFilterOptionsSourcesUnlistedItemRegExp)),
  }),
  visitTypes: zod.array(
    zod.object({
      id: zod.uuid().regex(appointmentFilterOptionsVisitTypesItemIdRegExp),
      name: zod.string(),
      telehealth: zod.boolean(),
    }),
  ),
})

export type AppointmentFilterOptions = zod.input<typeof AppointmentFilterOptions>
export type AppointmentFilterOptionsOutput = zod.output<typeof AppointmentFilterOptions>
